import React from 'react'

import { Route } from 'react-router'

import { MainLayout } from 'layouts/MainLayout'

import { DeliveryDetailsPage } from './DeliveryDetailsPage'

export const DeliveryDetails = (
  <Route component={MainLayout}>
    <Route path="/delivery-details" component={DeliveryDetailsPage} />
  </Route>
)
